<section [class.wants-border]="border" [class.is-warning]="isWarning" [class.no-background]="noBackground()" [class.is-muted]="isMuted">
  @if (label) {
    <header>
      @if (titleLink) {
        <div (click)="navigate()" class="can-click title"><i class="fa fa-fw fa-long-arrow-left"></i> {{ label }}</div>
      } @else {
        <div class="title">
          @if (logo) {
            <span> <img src="assets/svg/elogbooks-logo.svg" width="32px" height="32px" alt="logo" /> </span>
          }
          {{ label }}
        </div>
      }
      @if (checkboxes) {
        <div>
          @for (checkbox of checkboxes; track checkbox) {
            <span> {{ checkbox.title }}<i class="fa fa-fw fa-check-square-o"></i></span>
          }
        </div>
      }
      @if (toolbar) {
        <div class="toolbar no-print">
          @for (item of toolbar; track item) {
            <span [class.text-link]="item.text">
              @if (item.icon) {
                <i class="mdi {{ item.icon }}" (click)="toolbarClick(item)" title="{{ item.label }}" tooltipPosition="top"></i>
              }
              @if (item.text) {
                <span title="{{ item.label }}" [tooltipPosition]="item.tooltipposition" (click)="toolbarClick(item)"> {{ item.text }}</span>
              }
              @if (item.select && item.select.length) {
                <span>
                  <select (change)="selectChanged()">
                    @for (o of item.select; track o) {
                      <option [value]="o.id">{{ o.label }}</option>
                    }
                  </select>
                </span>
              }
            </span>
          }
        </div>
      }
      @if (rag) {
        <div>
          <div class="colours" [class.can-change]="canChangeRag">
            <div class="note-colour-red" (click)="clickRag('red')">
              <i class="fa fa-fw" [class.fa-circle-o]="rag !== 'red'" [class.fa-circle]="rag === 'red'"></i>
            </div>
            <div class="note-colour-orange" (click)="clickRag('amber')">
              <i class="fa fa-fw" [class.fa-circle-o]="rag !== 'amber'" [class.fa-circle]="rag === 'amber'"></i>
            </div>
            <div class="note-colour-green" (click)="clickRag('green')">
              <i class="fa fa-fw" [class.fa-circle-o]="rag !== 'green'" [class.fa-circle]="rag === 'green'"></i>
            </div>
          </div>
        </div>
      }
    </header>
  }
  <ng-content></ng-content>
</section>
